import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const exchange = async () => {
      const hash = window.location.hash;
      const match = hash.match(/session_id=([^&]+)/);
      if (!match) {
        navigate("/auth", { replace: true });
        return;
      }
      try {
        const { data } = await api.post("/auth/session", null, {
          headers: { "X-Session-ID": match[1] },
        });
        window.history.replaceState(null, "", window.location.pathname);
        setUser(data);
        const goDashboard = data.onboarding_complete || data.platform_role === "platform_admin";
        navigate(goDashboard ? "/dashboard" : "/onboarding", {
          replace: true,
          state: { user: data },
        });
      } catch {
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/auth", { replace: true });
      }
    };
    exchange();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background" data-testid="auth-callback-loading">
      <p className="text-muted-foreground text-lg">Signing you in…</p>
    </div>
  );
};
